// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3J05N","content":"Consent_content__27LlR","footer":"Consent_footer__2G8q9"};